import type { Transition } from 'history';
import { createBrowserHistory } from 'history';
import sortBy from 'lodash/sortBy';

export const history = createBrowserHistory();

export type BlockCallback = (tx: Transition) => boolean;
export type BlockCallbackInfo = {
  id: string;
  priority: number;
  callback: BlockCallback;
};
export type Unblock = () => void;

let unblock: Unblock | undefined;
const callbackInfoMap = new Map<string, BlockCallbackInfo>();

function setBlock() {
  if (!unblock && callbackInfoMap.size) {
    unblock = history.block((tx) => {
      const retry = () => {
        // remove block so transition can retry
        if (unblock) unblock();
        tx.retry();
        // restore block after retry
        setBlock();
      };

      const transition = {
        ...tx,
        retry
      };
      for (const callbackInfo of sortBy([...callbackInfoMap.values()], 'priority')) {
        const result = callbackInfo.callback(transition);
        if (result) {
          return;
        }
      }

      retry();
    });
  }
}

export function blockHistory(newCallbackInfo: BlockCallbackInfo) {
  callbackInfoMap.set(newCallbackInfo.id, newCallbackInfo);
  setBlock();
}

export function unblockHistory(id: string) {
  callbackInfoMap.delete(id);
  if (callbackInfoMap.size === 0 && unblock) {
    unblock();
    unblock = undefined;
  }
}
